import React, {useMemo} from 'react';
import style from './style.module.scss';
import {IProductSnippet} from 'shared/types/productSnippet.types';
import {LABELS_CODES} from 'components/ProductSnippet/ProductSnippet.constants';
import {ExpertsChoiceLabel} from './ExpertsChoiceLabel';
import {OnlineOnlyLabel} from './OnlineOnlyLabel';
import {InStockLabel} from './InStockLabel';
import {CustomerChoiceLabel} from './CustomerChoiceLabel';
import {IsNewLabel} from './IsNewLabel';
import {GiftInCartLabel} from './GiftInCartLabel';
import {GrowingDiscountLabel} from './GrowingDiscountLabel';

export interface ILabelsProps {
    labels: IProductSnippet['labels'];
    id: IProductSnippet['id'];
    onStockClick: IProductSnippet['analytics']['onStockClick'];
}

export const Labels = (props: ILabelsProps) => {
    const {labels = [], id, onStockClick} = props;

    const labelsList = useMemo(
        () =>
            labels.map((label) => {
                const labelId = `${id}/${label.code}`;

                if (label.code === LABELS_CODES.EXPERTS_CHOICE) {
                    return <ExpertsChoiceLabel key={label.code} {...label} id={labelId} />;
                }

                if (label.code === LABELS_CODES.ONLINE_ONLY) {
                    return <OnlineOnlyLabel key={label.code} {...label} id={labelId} />;
                }

                if (label.code === LABELS_CODES.IN_STOCK) {
                    return <InStockLabel key={label.code} {...label} id={labelId} onStockClick={onStockClick} />;
                }

                if (label.code === LABELS_CODES.CUSTOMER_CHOICE) {
                    return <CustomerChoiceLabel key={label.code} {...label} id={labelId} />;
                }

                if (label.code === LABELS_CODES.IS_NEW) {
                    return <IsNewLabel key={label.code} {...label} id={labelId} onStockClick={onStockClick} />;
                }

                if (label.code === LABELS_CODES.GIFT_IN_CART) {
                    return <GiftInCartLabel key={label.code} {...label} id={labelId} />;
                }

                if (label.code === LABELS_CODES.GROWING_DISCOUNT) {
                    return <GrowingDiscountLabel key={label.code} {...label} id={labelId} />;
                }

                return null;
            }),
        [id, labels, onStockClick],
    );

    if (!labelsList.length) {
        return null;
    }

    return (
        <div className={style.main} data-skeleton-item={''}>
            {labelsList}
        </div>
    );
};
